/* Littl 2027 — quick add for product cards: <button data-l-add="VARIANT_ID" data-qty="1"> */
(() => {
  if (window.__lQuickAdd) return;
  window.__lQuickAdd = true;
  const addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
  const cartUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-l-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true; b.classList.add('is-loading');
    try {
      const r = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.dataset.lAdd), quantity: Number(b.dataset.qty || 1) }] })
      });
      if (!r.ok) throw new Error('add failed');
      const cart = await (await fetch(cartUrl, { headers: { Accept: 'application/json' } })).json();
      document.dispatchEvent(new CustomEvent('littl:cart-changed', { detail: { cart } }));
      b.classList.add('is-added'); b.setAttribute('aria-label', 'Added to cart');
      setTimeout(() => { b.classList.remove('is-added'); b.setAttribute('aria-label', 'Add to cart'); }, 1800);
    } catch (err) {
      b.classList.add('is-error'); setTimeout(() => b.classList.remove('is-error'), 1600);
    } finally {
      b.disabled = false; b.classList.remove('is-loading');
    }
  });
})();
